export default __webpack_public_path__ + "static/media/favicon.41adc498.svg";